<template>
  <div class="branches_table region_table grey loading_table">    
    <b-loading :is-full-page="false" :active="isLoading"></b-loading>     
    <b-table 
      ref="table"
      :data="commissionsList.data" 
      :show-detail-icon="false"
      @click="openInfo"
      detailed
      paginated
      :per-page="15"
      pagination-simple
      @page-change="changePage"
      backend-pagination
      :total="commissionsList.total"
    >
      <template slot-scope="props">
         <b-table-column width="10%" label="id" :visible="true" field="members" :centered="false">
          <div>{{ props.row.id }}</div>
        </b-table-column>
        <b-table-column width="50%" label="Название комиссии" :visible="true" field="members" :centered="false">
          <div>{{ props.row.name }}</div>
        </b-table-column>
        <b-table-column width="40%" :visible="true" field="members" :centered="false">
          <div class="button_actions">
            <button class="add_branch add_course" @click="$event.stopPropagation(); $emit('commission-edit', props.row)">
              <i class="mdi mdi-account-edit"></i> Редактировать
            </button>
             <button class="add_branch add_course" @click="$event.stopPropagation(); $emit('delete', props.row.id)">
              <i class="mdi mdi-folder-remove-outline"></i> Удалить
            </button>
          </div>
        </b-table-column>
      </template>
      <template slot="detail" slot-scope="props">
        <span class="grey">
          <b-table
            class="commission-detail"
            :data="props.row.members" 
            :show-detail-icon="false"
            paginated
            :per-page="15"
            pagination-simple
            pagination-size="is-small"
          >
            <template slot-scope="innerProps">
              <b-table-column width="50%" label="ФИО" :visible="true" field="members" :centered="false">
                <div>{{ `${innerProps.row.surname} ${innerProps.row.name} ${innerProps.row.patronymic}` }}</div>
              </b-table-column>
               <b-table-column width="50%" label="Должность" :visible="true" field="members" :centered="false">
                <div>{{ innerProps.row.position }}</div>
              </b-table-column>
            </template>
          </b-table>
        </span>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    commissionsList: {
      default: () => {},
      type: Object
    },
    isLoading: {
      default: () => true,
      type: Boolean
    },
  },
  data() {
    return {
      openedRow: {}
    }
  },
  methods: {
    openInfo(row) {
      if (row != this.openedRow) {
        this.$refs.table.toggleDetails(this.openedRow)
        this.$refs.table.toggleDetails(row)
        this.openedRow = row
        return
      }
      this.$refs.table.toggleDetails(row)
      this.openedRow = {}

    },
    changePage(val) {
      this.$emit('changePage', val)
    },
  }
}
</script>